import React, { useState, useEffect } from 'react'
import get from 'lodash/get'

import CreditStepList from './components/CreditStepList'
import CreditInitialPage from './components/CreditInitialPage'
import CreditNavbar from './components/CreditNavbar'
import CreditFooter from './components/CreditFooter'
import fetchCrawlerData from '../../services/fetch-crawler-data'
import finishSignup from '../../services/finish-signup'

import './style.scss'

const CreditVerification = () => {
  const urlParams = new URLSearchParams(window.location.search)
  /* Legacy conversion params. Can be removed in the near future when no more links depend on it */
  const sourceId = urlParams.get('signup_id')
  const source = urlParams.get('signup_source') || 'olx'
  /* */
  const announcementId = urlParams.get('signup_ref')
  const token = urlParams.get('token')
  const customSignup = async (data, facebookToken) =>
    finishSignup(
      announcementId,
      { source, sourceId, token },
      { data, facebookToken, conversionFrom: 'credit-web' },
    )

  const [steps, setSteps] = useState(false)
  const [urlData, setUrlData] = useState()
  useEffect(() => {
    async function fetchData() {
      if (urlData === undefined) {
        if (!sourceId && !announcementId) {
          setUrlData(null)
          return
        }

        try {
          const { rawAnnouncement } = await fetchCrawlerData(announcementId, {
            source,
            sourceId,
            token,
          })

          setUrlData({
            name: get(rawAnnouncement, 'editable.landlord_name', ''),
            phone: get(rawAnnouncement, 'editable.landlord_phone', ''),
          })
        } catch (error) {
          setUrlData(null)
        }
      }
    }
    fetchData()
  }, [announcementId, source, sourceId, token, urlData]) // eslint-ignore
  const handleNextStep = (item) => setSteps(item)

  if (urlData !== undefined) {
    return (
      <div>
        <CreditNavbar />

        <div>
          {steps ? (
            <CreditStepList urlData={urlData} customSignup={customSignup} />
          ) : (
            <CreditInitialPage handleClick={() => handleNextStep(true)} />
          )}
        </div>

        <CreditFooter />
      </div>
    )
  }

  return null
}

export default CreditVerification
